import Header from 'components/common/Header';
import SubNavigation from 'components/common/SubNavigation';

const AdministrationHeader: React.FC = () => {
  const administrationTabs = [
    {
      id: 1,
      path: '/administration/creatives',
      isVisible: true,
      name: 'Creatives',
    },
  ];

  return <Header title="Administration" subNavigation={<SubNavigation tabsConfig={administrationTabs} />} />;
};

export default AdministrationHeader;
